import { calculateAPR } from './calculateAPR';
import { formatAmount } from './formatAmount';

export const updateAprAndAprRelatedClosingCost = (
  form: any,
  index: string | number,
  oldValue: number,
  newValue: number
) => {
  const aprRelatedClosingCost = parseFloat(form.getFieldValue(['loans', index, 'aprRelatedClosingCost','value'])) || 0;
  const loanAmount = parseFloat(form.getFieldValue(['loans', index, 'loanAmount', 'value'])) || 0;
  const interestRate = parseFloat(form.getFieldValue(['loans', index, 'interestRate', 'value'])) || 0;
  const loanPeriodInYears = parseFloat(form.getFieldValue(['loans', index, 'loanPeriodInYears', 'value'])) || 0;
  const closingCostsClearedAt = form.getFieldValue(['loans', index, 'externalLoan', 'closingCostsClearedAt']);

  const totalAprRelatedClosingCost = (aprRelatedClosingCost - oldValue) + newValue;

  const normalizedAprClosingCost = parseFloat(formatAmount(Math.max(0, totalAprRelatedClosingCost)));

  const apr = calculateAPR(loanAmount, interestRate, loanPeriodInYears, normalizedAprClosingCost);

  form.setFieldValue(['loans', index, 'apr', 'value'], apr);

  form.setFieldValue(['loans', index, 'aprRelatedClosingCost', 'value'],
    closingCostsClearedAt ? aprRelatedClosingCost : formatAmount(normalizedAprClosingCost));
};
